import { TableLogisticPartners } from '../../components'

export const TabLogisticImporters = () => {
  return (
    <div>
      <TableLogisticPartners externalFilter={{ type: 'import_company' }} />
    </div>
  )
}
